import { render } from "./TeamReportFrontPage.vue?vue&type=template&id=4f857346&scoped=true"
import script from "./TeamReportFrontPage.vue?vue&type=script&lang=js"
export * from "./TeamReportFrontPage.vue?vue&type=script&lang=js"

import "./TeamReportFrontPage.vue?vue&type=style&index=0&id=4f857346&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f857346"]])

export default __exports__